import { render, staticRenderFns } from "./Landlord.vue?vue&type=template&id=2577571e&scoped=true&"
import script from "./Landlord.vue?vue&type=script&lang=js&"
export * from "./Landlord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577571e",
  null
  
)

export default component.exports